import { GenericService } from "./Generic.service";

export class DependentesService extends GenericService<string> {
  readonly URI: string = "Dependente";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async upload(body: any, id: string) {
    return await super.postByResourceHeadersTwo(body, id, "Upload/CSV");
  }

  public async postActivate(body: any){
    return await super.postByResource(body, "Activate")
  }

  public async postInactivate(body: any){
    return await super.postByResource(body, "Inactivate")
  }  
  
}